import React from 'react'
import { Flex } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'

const Container = styled(Flex)({
  justifyContent: 'flex-start',
  padding: '20px 10px'
})

const PlaylistText = styled(Text)({
  fontSize: ['16px'],
  fontFamily: 'Proxima-nova'
})

const BackButton = () => {
  // Get query params
  const params = new URLSearchParams(window.location.search)
  const callbackUrl = params.get('redirect_to')

  // If no redirect_to, dont render back button
  if (!callbackUrl) return null

  let safeCallbackUrl = null

  try {
    const decoded = decodeURIComponent(callbackUrl)

    // Allow only internal relative paths
    if (
      decoded.startsWith('/') &&
      !decoded.startsWith('//') &&
      !decoded.includes('://')
    ) {
      safeCallbackUrl = new URL(decoded, window.location.origin).toString()
    }
  } catch {
    return null
  }

  if (!safeCallbackUrl) return null

  const fromClassPage = safeCallbackUrl.includes('/workouts/')
  const buttonText = fromClassPage ? 'Back to Class' : 'Back to Program'
  return (
    <Container onClick={() => (window.location.href = safeCallbackUrl)}>
      <PlaylistText>{`< ${buttonText}`}</PlaylistText>
    </Container>
  )
}

export default BackButton
